import type React from 'react';

type GalaxyProps = {
  size: number;
  color: string;
  animationDuration?: number;
  style?: React.CSSProperties;
};

export default function Galaxy({
  size = 500,
  color = 'rgba(147, 51, 234, 0.2)',
  animationDuration = 20,
  style
}: GalaxyProps) {
  return (
    <div
      className="galaxy-container"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        animation: `galaxy-animation ${animationDuration}s linear infinite`,
        position: 'absolute',
        ...style
      }}
    >
      <div
        className="galaxy-ring"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '70%',
          height: '40%',
          border: `2px dashed ${color}`,
          borderRadius: '50% / 50%',
          transform: 'translate(-50%, -50%)'
        }}
      ></div>
      <div
        className="galaxy-ring"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '70%',
          height: '40%',
          border: `2px dashed ${color}`,
          borderRadius: '50% / 50%',
          transform: 'translate(-50%, -50%) rotate(90deg)'
        }}
      ></div>
    </div>
  );
}
